import { useGlobals } from './compositions/useGlobals'
import { InternalMethods } from '@/shared/apis/messages'
import { logInfo } from '@/shared/logger'

/**
 * //locks the app after 10 minutes of inactivity
 */
const KEEP_ALIVE_DEBOUNCE_MS = 5000
let timeout: NodeJS.Timeout | undefined
const resetTimer = () => {
  if (timeout) {
    clearTimeout(timeout)
    timeout = undefined
  } else {
    logInfo('popup sending keep alive (start debounce)')
    useGlobals().sendMessage({
      method: InternalMethods.KEEP_ALIVE,
      payload: undefined,
    })
  }
  timeout = setTimeout(() => {
    timeout = undefined
    logInfo('popup sending keep alive (end debounce)')
    useGlobals().sendMessage({
      method: InternalMethods.KEEP_ALIVE,
      payload: undefined,
    })
  }, KEEP_ALIVE_DEBOUNCE_MS)
}

const autoLock = (): void => {
  window.addEventListener('load', resetTimer)
  window.addEventListener('mousemove', resetTimer)
  window.addEventListener('mousedown', resetTimer) // catches touchscreen presses as well
  window.addEventListener('touchstart', resetTimer) // catches touchscreen swipes as well
  window.addEventListener('click', resetTimer) // catches touchpad clicks as well
  window.addEventListener('keydown', resetTimer)
  window.addEventListener('scroll', resetTimer, true)
}

export default autoLock
